/**
 * デバイス情報取得用共通処理
 */
import {
  isArgActivateDeviceInfo,
  isArgGetDeviceInfo,
  isArgUpdateDeviceInfo,
  type ArgActivateDeviceInfo,
  type ArgGetDeviceInfo,
  type ArgUpdateDeviceInfo,
  type ResActivateDeviceInfo,
  type resActivateDeviceInfo,
  type ResGetDeviceInfo,
  type ResGetDeviceInfoResult,
  type resUpdateDeviceInfo
} from '@/types/accessor/api/device/deviceInfoTypes'
import { AuthDeviceDB } from '../../indexedDB/authDeviceDB'
import MiiaFwConfig from '@/configs/config'
import { useApiGw } from '@/modules/miiaFw/composables/useApiGw'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { GlobalError } from '@/utils/globalError/GlobalError'

const authDeviceDB = AuthDeviceDB.instance

export const getDeviceInfoDaoApi = async (
  arg: ArgGetDeviceInfo
): Promise<ResGetDeviceInfoResult> => {
  const { invokeApiGwFunc } = useApiGw()
  const deviceToken = await authDeviceDB.getDeviceToken()
  return await new Promise((resolve, reject) => {
    if (isArgGetDeviceInfo(arg)) {
      invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.authEndpoint,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        '/devices',
        // Lambda関数に渡す引数
        {
          function: 'get',
          params: { ...arg, deviceToken: deviceToken }
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (data: ResGetDeviceInfo) => {
          resolve(data.result)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        (message: ResGetDeviceInfo) => {
          reject({ message })
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject('API実行に失敗しました。(原因: アクセス回線障害など)')
        },
        // 処理完了後に実行するコールバック
        () => {},
        false
      )
    } else {
      reject(() => {
        throw new GlobalError([ERROR_CODES.COMMON_DEVICE_GET_ARG_INVALID])
      })
    }
  })
}

export const activateDeviceInfoDaoApi = async (
  arg: ArgActivateDeviceInfo
): Promise<ResActivateDeviceInfo> => {
  const { invokeApiGwFunc } = useApiGw()
  return await new Promise((resolve, reject) => {
    if (isArgActivateDeviceInfo(arg)) {
      invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.authEndpoint,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        '/devices',
        // Lambda関数に渡す引数
        {
          function: 'activate',
          params: arg
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (data: resActivateDeviceInfo) => {
          resolve(data.result)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        (message: resActivateDeviceInfo) => {
          reject({ message })
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject('API実行に失敗しました。(原因: アクセス回線障害など)')
        },
        // 処理完了後に実行するコールバック
        () => {},
        false
      )
    } else {
      reject(() => {
        throw new GlobalError([ERROR_CODES.COMMON_DEVICE_ACTIVATION_ARG_INVALID])
      })
    }
  })
}

export const updateDeviceInfoDaoApi = async (
  arg: ArgUpdateDeviceInfo
): Promise<resUpdateDeviceInfo> => {
  const { invokeApiGwFunc } = useApiGw()
  const deviceToken = await authDeviceDB.getDeviceToken()
  return await new Promise((resolve, reject) => {
    if (isArgUpdateDeviceInfo(arg)) {
      invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.authEndpoint,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        '/devices',
        // Lambda関数に渡す引数
        {
          function: 'update',
          params: { ...arg, deviceToken: deviceToken }
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (data: resUpdateDeviceInfo) => {
          resolve(data)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        (message: resUpdateDeviceInfo) => {
          reject({ message })
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject('API実行に失敗しました。(原因: アクセス回線障害など)')
        },
        // 処理完了後に実行するコールバック
        () => {},
        false
      )
    } else {
      reject(() => {
        throw new GlobalError([ERROR_CODES.COMMON_DEVICE_UPDATE_ARG_INVALID])
      })
    }
  })
}
